import { render } from "./AreaComponent.vue?vue&type=template&id=d0f6c764"
import script from "./AreaComponent.vue?vue&type=script&lang=js"
export * from "./AreaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__